import { createReducer } from "@reduxjs/toolkit";
import { resetRetrieveAdminBatchDetail, retrieveAdminBatchDetail } from "./retrieve-admin-batch-detail";
import type { RetrievalState } from "@redux/state/shared-types";
import type { AdminBatchDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

const initialState: RetrievalState<Nullable<AdminBatchDetailVM>> = {
  fetching: "idle",
  data: null,
};

export const retrieveAdminBatchDetailReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveAdminBatchDetail.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveAdminBatchDetail.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveAdminBatchDetail.rejected, state => {
      state.fetching = "failed";
    })
    .addCase(resetRetrieveAdminBatchDetail, () => {
      return initialState;
    });
});
